import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MsRegistrationFormFacadeService } from './ms-registration-form.facade.service';

@Injectable({
  providedIn: 'root',
})
export class MSService {
  constructor(private msFacadeService: MsRegistrationFormFacadeService) {}

  redirect() {
    let url =
      environment.msRedirectToMSTATURL +
      `?first_name=${this.msFacadeService.fName}&last_name=${this.msFacadeService.lName}&card_number=${this.msFacadeService.cNumber}`;
    return (window.location.href = url);
  }
}
